<template>
  <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile" style="border: .08em solid #eee">
    <p id="tituloPainel" class="card-dados__titulo mb-0" style="font-weight: 600; color: #777; background-color: #cfcfcf; padding: 0.6rem 0.8rem;">Listagem</p>

    <div v-if="value.length > 1" class="text-xs-right acao-expandir-recolher">
      <v-btn v-if="ultimoEstadoPaineis === 'recolhido'" flat @click="expandirTodos" class="botao-simples mr-3">
        <v-icon left size="15">fas fa-chevron-down</v-icon>
        Expandir Todos
      </v-btn>
      <v-btn v-else flat @click="recolherTodos" class="botao-simples mr-3">
        <v-icon left size="15">fas fa-chevron-up</v-icon>
        Recolher Todos
      </v-btn>
    </div>

    <v-expansion-panel v-model="paineis" expand class="painel-itens" :class="{ 'mt-3': value.length > 1}">
      <v-expansion-panel-content v-for="lote in value" :key="lote.id" class="painel-itens__linha cabecalho-painel">
        <template v-slot:header>
          <p>
            <strong>{{ lote.descricao }}</strong> -
            <v-tooltip top v-if="lote.motivo">
              <a slot="activator">
                {{ lote.situacao | azEnum(situacoesItensELotes) }}
                <i class="fas fa-comment" aria-hidden="true"/>
              </a>
              {{ lote.motivo }}
            </v-tooltip>
            <span v-else>
                            {{ lote.situacao | azEnum(situacoesItensELotes) }}
                        </span>
          </p>
          <div style="display: flex">
            <p>Exclusivo {{formatarLista(portes) | azConcat}}:</p>
            <p class="ml-2">{{ lote.porteExclusivo ? 'Sim' : 'Não' }}</p>
          </div>

        </template>

        <painel-lote-tabela
            :itens="lote.itens"
            :possuiValorReferencia="possuiValorReferencia"
            :exibirValorDeReferencia="exibeValorReferencia"
            :prefixOuSuffixValor="prefixOuSuffixValorCurrency"
            :criterioJulgamento="criterioJulgamentoDaCompra"
            :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
            :casasDecimais="casasDecimais"
            :casasDecimaisQuantidade="casasDecimaisQuantidade"/>

      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-flex>
</template>

<script>
import PainelLoteTabela from './PainelLoteTabela'
import constantMixin from '@/core/mixins/constant'

export default {
    name: 'PainelLoteVisualizacao',
    mixins: [constantMixin],
    components: {
        PainelLoteTabela
    },
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        prefixOuSuffixValor:{
            type: String
        },
        criterioJulgamento: {
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        possuiValorReferencia:{
            type: Boolean
        },
        exibeValorReferencia: {
            type: Boolean,
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            paineis: [],
            totalmenteExpandido: false,
            totalmenteRecolhido: true,
            ultimoEstadoPaineis: 'recolhido'
        }
    },
    computed: {
        total() {
            let total = 0
            this.value.forEach(lote => {
                if (lote.totalGeral > 0) {
                    total += lote.totalGeral
                }
            })
            return total
        },
        prefix(){
            return this.prefixOuSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixOuSuffixValor === '%' ? '%' : ''
        },
        criterioJulgamentoDaCompra(){
            return this.criterioJulgamento
        },
        prefixOuSuffixValorCurrency(){
            return this.prefixOuSuffixValor
        }
    },
    mounted() {
        this.expandirTodos()
    },
    methods: {
        recolherTodos() {
            const todosPaineisFechados = this.value.map(() => {
                return false
            })
            this.paineis = todosPaineisFechados
            this.totalmenteExpandido = false
        },
        expandirTodos() {
            const todosPaineisAbertos = this.value.map(() => {
                return true
            })
            this.paineis = todosPaineisAbertos
            this.totalmenteExpandido = true
            this.verificarUltimoEstado()
        },
        verificarUltimoEstado() {
            if (this.totalmenteExpandido) {
                this.ultimoEstadoPaineis = 'expandido'
            } else if (this.totalmenteRecolhido) {
                this.ultimoEstadoPaineis = 'recolhido'
            }
        }
    },
    watch: {
        paineis() {
            let todosExpandidos = true
            let todosRecolhidos = true

            for (let posicao of this.paineis) {
                if (!posicao) {
                    todosExpandidos = false
                } else {
                    todosRecolhidos = false
                }
            }

            this.totalmenteExpandido = todosExpandidos
            this.totalmenteRecolhido = todosRecolhidos
            this.verificarUltimoEstado()
        }
    }
}
</script>

<style scoped>
.painel-itens__info {
  margin-right: 20px;
}

@media (max-width: 720px) {
    .painel-itens__info {
        margin-right: 10px;
    }
}
</style>
